import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
/**
 * Service class to handle authentication.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: string = '';

  constructor(
    private http: HttpClient
  ) { }

  getToken() {
    return this.token ? this.token : sessionStorage.getItem('api_key');
  }

  setToken(token: string) {
    this.token = token;
    sessionStorage.setItem('api_key', token);
  }

  authenticateLMS(username: string, password: string) {
    return this.http.post(environment.authURL, {username, password});
  }

  authenticate(userName: string, password: string, isIdeLogin?: boolean, isMobileLogin?: true) {
    let encodedCreds = btoa(`${userName}:${password}`);
  
    let payload = {
      ...(isIdeLogin ? 
            {isIdeLogin: isIdeLogin}
          :
            (isMobileLogin && {isMobileLogin: isMobileLogin})
        )
    }
    return this.http.post(`${environment.apiURL}/admin/login`, payload,
      {
        headers: {'auth': `Basic ${encodedCreds}`}
      }
    )
  }

  verifyIp(token: string = "") {
    return this.http.get(`${environment.apiURL}/admin/check-ip`, {
      headers: { 'auth': token }
    });
  }
}